import __ from "standard/dunder";
import resolver from "./resolver";

const truthy = (value) => !!value;

export default resolver(__.truthy__, truthy);
